import { useFlags } from 'launchdarkly-react-client-sdk';

// FINTECH-4319..4845 self-serve pilot. Dispensary/enterprise-targetable via the existing
// `ecomm-dispensary`/`ecomm-enterprise` LD contexts set globally in
// `useLaunchDarklyClientContext` (falls back to `window.reactEnv`, so it still resolves on
// `/account/*` routes that have no `cName`). This is a rollout dial, not a killswitch: it
// defaults to FALSE when absent/unavailable, the opposite convention of
// `usePhoneVerificationNudgeOperational` -- an absent/unavailable rollout flag must never
// silently turn a not-yet-approved surface on.
const SELF_SERVE_PHONE_VERIFICATION_ROLLOUT_FLAG = 'ecomm.account.self-serve-phone-verification.rollout';

/**
 * Whether the self-serve phone-verification pilot is enabled for the current dispensary/
 * enterprise. Independent of the loyalty-redemption gate and of the legacy nudge banner's own
 * killswitch (`usePhoneVerificationNudgeOperational`) -- this is the ONLY gate for the net-new
 * self-serve Verify button (`self-serve-phone-verify/`, FINTECH-4845). It is never OR'd with, or
 * otherwise composed with, that legacy killswitch -- there is no shared/composed gate hook.
 */
export function useSelfServePhoneVerificationRollout(): boolean {
  const flags = useFlags();

  return Boolean(flags[SELF_SERVE_PHONE_VERIFICATION_ROLLOUT_FLAG] ?? false);
}
